export default __webpack_public_path__ + "static/media/elisabeth.992cf784.jpg";